var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"summer-sale-badge"},[_vm._v("Summer Sale")])
}
var staticRenderFns = []

export { render, staticRenderFns }